import { SquareDotLoadingIndicator, Text } from '@joor/design-system'
import styled from 'styled-components'

import { Flex } from 'styles/components'

import { useUnmatchedUploads } from '../../manageImagesModal.hooks'
import { GalleryIds } from '../../manageImagesModal.ids'
import messages from '../../manageImagesModal.messages'
import useStore from '../../store/useManageImagesStore'
import ActionBar from './components/ActionBar/ActionBar'
import EmptyGallery from './components/EmptyGallery/EmptyGallery'
import GalleryGrid from './components/GalleryGrid/GalleryGrid'
import ImageUpload from './components/ImageUpload/ImageUpload'

const GalleryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  overflow-y: auto;
`

const GalleryView = (): JSX.Element => {
  const { loading: isLoadingImages, images } = useUnmatchedUploads()
  const isRemovingImages = useStore((state) => state.isRemovingImages)
  const isUploadingImages = useStore((state) => state.isUploadingImages)

  const isLoading = isLoadingImages || isRemovingImages || isUploadingImages

  return (
    <GalleryContainer data-testid={GalleryIds.Container}>
      <ActionBar isLoading={isLoading} />
      {isLoading && (
        <>
          {isUploadingImages && <ImageUpload />}
          {!isUploadingImages && (
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              gap="8px"
              flex={1}
            >
              <SquareDotLoadingIndicator />
              {isRemovingImages && (
                <Text fontWeight="medium" letterSpacing="tighter">
                  {messages.removingImages}
                </Text>
              )}
            </Flex>
          )}
        </>
      )}
      {!isLoading && (
        <>
          {!images?.length && <EmptyGallery />}
          {!!images?.length && <GalleryGrid images={images} />}
        </>
      )}
    </GalleryContainer>
  )
}

export default GalleryView
